<template>

  <div>
     <component v-if=""v-bind:is="show_design" :survey="survey" />
  </div>

</template>

<script>

const comp = {
  'Alphonso': function () { return import('@core/components/survey/style/default.vue') }

}

export default{

  components: comp,

  props: {survey: Object, design: String},

  data: function () {
    return {
      show_design: this.design,
      pass: ''
    }
  }

}

</script>
